import { BehaviorSubject, map, Observable, of } from "rxjs";

import { CoinFacade } from "./coin.facade";
import { ExtendedApiResponse, SupportedCoinDto, SupportedCoinsResponse } from "@coin-depo-types";

export abstract class CoinBaseService implements CoinFacade {
  protected abstract supportedCoins$: BehaviorSubject<SupportedCoinDto[]>;

  get allCachedSupportedCoins$(): Observable<SupportedCoinDto[]> {
    return this.supportedCoins$.asObservable();
  }

  get cachedSupportedCoins$(): Observable<SupportedCoinDto[]> {
    return this.supportedCoins$.asObservable().pipe(
      map(coins => coins.filter(c => c.is_active === 1))
    );
  }

  getSupportedCoinsSnapshot(): SupportedCoinDto[] {
    return this.supportedCoins$.value;
  }

  getSupportedCoinsByNameSnapshot(name: string): SupportedCoinDto | undefined {
    return this.supportedCoins$.value.find(c => c.coin_name === name);
  }

  getSupportedCoinsByIdSnapshot(id: string | number): SupportedCoinDto | undefined {
    return this.supportedCoins$.value.find(c => c.coin_id === Number(id));
  }

  abstract updateSupportedCoins(): Observable<ExtendedApiResponse<SupportedCoinsResponse>>;

  // Admin method overrided in AdminCoinsService
  getVestingCSVAdmin(payload: { coin_id: number, user_user_id: number }): Observable<any> {
    return of(null);
  }

  getSupportedCoinsByLogoName(name: string): SupportedCoinDto | undefined  {
    return this.supportedCoins$.value.find((coin) => coin.logo_name === name);
  }
}